import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import Shield from 'assets/icons/shield_lock.svg';
import { personalData } from 'common/schema/personal-data';
import { SubtitleMedium, SubtitleMediumBold } from 'common/typography/SubtitleMedium';
import { TitleMedium } from 'common/typography/TitleMedium';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FlexButton } from 'shared/components/Button/FlexButton';
import { StepOneProps } from 'shared/components/Form/MultiStepForm/StepOne/types';
import { CheckboxWrapper } from 'shared/components/Form/MultiStepForm/style';
import Inputs from 'shared/components/Inputs/FormInput';
import { theme } from 'styles/global-themes';
import {
  BoxCheckbox,
  CenterImage,
  CheckboxInput,
  CheckboxLabel,
  IconWrapper,
  StepWrapper,
  TermsLink,
  TextBox,
} from './style';

export const StepOne: React.FC<StepOneProps> = ({ onNextStep ,defaultValues }) => {
  const {
    handleSubmit,
    getValues,
    control,
    formState: { isValid },
    trigger,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(personalData),
    defaultValues:{
      ...defaultValues,
      phoneNumber:defaultValues.phoneRaw
    }
  });

  const onSubmit = () => {
    const values = getValues();
    const onlyNumbers = values.phoneNumber.replace(/\D/g, '');
    const phoneAreaCode = onlyNumbers.slice(0, 2);
    const phoneNumber = onlyNumbers.slice(2);
    onNextStep({
      ...values,
      phoneAreaCode,
      phoneNumber,
      marketing: values.marketing ?? false,
      terms: values.terms ?? false,
      phoneRaw: values.phoneNumber
    });
  };

  useEffect(() => {
    if(defaultValues.email){
      trigger();
    }
  },[trigger])

  return (
    <StepWrapper>
      <Box textAlign="center">
        <TextBox>
          <TitleMedium color={theme.palette.common.black}>Como podemos te contatar?</TitleMedium>
          <SubtitleMedium color={'#5F5E60'}>Abaixo, preencha seus dados de contato.</SubtitleMedium>
        </TextBox>
      </Box>

      <Box display="flex" flexDirection="column" gap={2.9}>
        <Inputs control={control} name="email" label="E-mail" placeholder="E-mail" />

        <Inputs control={control} name="phoneNumber" label="Número de celular" placeholder="DDD + celular" maskType="phone" />

        <TextBox>
          <BoxCheckbox>
            <Controller
              name="marketing"
              control={control}
              render={({ field }) => 
                <CheckboxWrapper>
                  <CheckboxInput
                    id="marketing"
                    type="checkbox"
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                  <CheckboxLabel htmlFor="marketing">
                    <SubtitleMediumBold color={theme.palette.common.black}>
                      Aceito receber comunicação pelas formas de contato
                    </SubtitleMediumBold>
                  </CheckboxLabel>
                </CheckboxWrapper>
              }
            />

            <Controller
              name="terms"
              control={control}
              render={({ field }) => 
                <CheckboxWrapper>
                  <CheckboxInput
                    id="terms"
                    type="checkbox"
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                  <CheckboxLabel htmlFor="terms">
                    <SubtitleMediumBold color={theme.palette.common.black}>
                      Estou de acordo com os <TermsLink href="/termos-de-uso">Termos de uso</TermsLink> e as{' '}
                      <TermsLink href="/politica-de-privacidade">Políticas de Privacidade</TermsLink>
                    </SubtitleMediumBold>
                  </CheckboxLabel>
                </CheckboxWrapper>
              }
            />
          </BoxCheckbox>
          <FlexButton
            $backgroundColor={!isValid ? '#161C274D' : '#161C27'}
            text="Continuar"
            disabled={!isValid}
            handleClick={handleSubmit(onSubmit)}
          />

          <SubtitleMedium color={theme.palette.common.black}>
            <CenterImage>
              <IconWrapper src={Shield} alt="shield_lock" />
              Seus dados estão 100% protegidos e seguros
            </CenterImage>
          </SubtitleMedium>
        </TextBox>
      </Box>
    </StepWrapper>
  );
};
